import React from 'react'
import cx from 'classnames'
import Spinner from 'components/Spinner'
import styles from './ContentLoading.sass'

const ContentLoading = ({ size, compact }: Props) => (
  <div className={cx(styles.content, compact && styles.compact)}>
    <Spinner size={size} />
  </div>
)

interface Props {
  size?: number
  compact?: boolean
}

export default ContentLoading
